import { KbFolderInput, KbFolderModel } from 'types/KbFolderTypes';
import useHttp from '../helpers/HttpMethods';

class KbFoldersService {
  static async create(body: KbFolderInput): Promise<KbFolderModel> {
    return await useHttp().post(body, '/kb-folders');
  }

  static async update(
    kbFolderId: number,
    body: KbFolderInput
  ): Promise<KbFolderModel> {
    return await useHttp().put(body, `/kb-folders/${kbFolderId}`);
  }

  static async delete(kbFolderId: number): Promise<void> {
    return await useHttp().del(`/kb-folders/${kbFolderId}`);
  }

  static async moveFoldersToGroup(payload: {
    kbFolderIds: number[];
    targetKbGroup: { id: number };
  }): Promise<Response> {
    return await useHttp().post(payload, '/kb-folders/batch-move');
  }
}

export default KbFoldersService;
